import React from 'react';
import { m as motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { FULL_MOCKUP_URL } from '../data/images';
import { BASE_CHECKOUT_URL, KIT_CHECKOUT_URL } from '../data/checkoutLinks';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function FinalCTA() {
  return <section className="relative overflow-hidden bg-mp-black py-20 md:py-28" data-id="element-101" data-mp="m3x04y62j5ko">
      <div className="pointer-events-none absolute inset-0 court-lines opacity-40" aria-hidden="true" data-id="element-102" data-mp="h6dhlm2c86mx" />
      <div className="pointer-events-none absolute inset-0" style={{
      background: 'radial-gradient(ellipse at 50% 20%, rgba(8,93,168,0.3), transparent 65%)'
    }} aria-hidden="true" data-id="element-103" data-mp="vv1djtg3iide" />
      <Container className="relative z-10 text-center" data-id="element-104" data-mp="14whllujfu8eg">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: easeOut
      }} data-id="element-105" data-mp="zwd6a7u9njpt">
          <SectionTag tone="white" data-id="element-106" data-mp="2h2y5n518c3qr">La próxima clase llegará igualmente.</SectionTag>
          <h2 className="mx-auto mt-5 max-w-[820px] font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-107" data-mp="2m340sv6pk8dl">
            La pregunta es si volverás a improvisarla.
          </h2>

          <p className="mx-auto mt-6 max-w-[600px] text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-108" data-mp="2v428pok9p01g">
            Necesitas saber qué trabajar, por qué trabajarlo, cómo corregirlo y qué viene después. Eso es Maestro
            en Pista.
          </p>

          <p className="mx-auto mt-5 max-w-[600px] text-xs uppercase tracking-wide text-mp-gray/70 md:text-sm" data-id="element-109" data-mp="34vf0kg62fq7h">
            5 tomos · 250+ páginas · 5 bonos · Garantía 14 días · El precio de un menú del día.
          </p>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: easeOut
      }} src={FULL_MOCKUP_URL} alt="Sistema completo Maestro en Pista" width={600} height={600} loading="lazy" className="mx-auto mt-12 w-full max-w-[380px]" data-id="element-110" data-mp="3islhe578beu2" />

        <div className="mx-auto mt-10 grid max-w-[760px] grid-cols-1 gap-5 text-left sm:grid-cols-2" data-id="element-111" data-mp="1nodowy22n3kh">
          <div className="rounded-2xl border border-mp-border bg-mp-dark/80 p-6" data-id="element-112" data-mp="22d9tgl4x5ygc">
            <p className="font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-113" data-mp="1xeyiu86svjx2">Maestro en Pista</p>
            <p className="mt-3 font-heading text-4xl text-mp-white" data-id="element-114" data-mp="2be7wb03mfzxc">16,90 €</p>
            <p className="font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-115" data-mp="27dnzxyqvh0c9">Pago único</p>
            <CTAButton href={BASE_CHECKOUT_URL} variant="secondary" className="mt-5 w-full" showArrow data-id="element-116" data-mp="h2jhqz1axzdh">
              Versión base
            </CTAButton>
          </div>

          <div className="relative rounded-2xl border-2 border-mp-lime bg-mp-dark/80 p-6 shadow-glow-lime" data-id="element-117" data-mp="2w82x7td6gz2">
            <span className="absolute -top-3 left-6 rounded-full bg-mp-lime px-3 py-1 font-heading text-[10px] font-bold uppercase tracking-wide text-mp-black" data-id="element-118" data-mp="6y32o7vncmaq">
              Recomendado
            </span>
            <p className="mt-2 font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-119" data-mp="3u9uanroyidxo">
              Maestro en Pista + Kit de Ejecución
            </p>
            <p className="mt-3 font-heading text-4xl text-mp-lime" data-id="element-120" data-mp="3ffhbe5otl4mh">21,90 €</p>
            <p className="font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-121" data-mp="3ke0yi9f5gmgf">
              Solo 5 € más que la versión base
            </p>
            <CTAButton href={KIT_CHECKOUT_URL} className="mt-5 w-full" showArrow data-id="element-122" data-mp="3bb9lw6ajfkn7">
              Quiero todo incluido
            </CTAButton>
          </div>
        </div>

        <p className="mt-6 text-center text-xs text-mp-gray sm:text-sm" data-id="element-123" data-mp="14jh8b2z8gtfi">
          💳 Pago único &nbsp;·&nbsp; ⚡ Acceso inmediato &nbsp;·&nbsp; 🛡️ Garantía 14 días &nbsp;·&nbsp; Sin
          suscripción
        </p>
      </Container>
    </section>;
}